export const yearService = {

    generateYears(startYear = 1900) {
        let years = [];
        let endYear = new Date().getFullYear();
        for (var i = startYear; i <= endYear; i++) {
            years.push(i);
        }
        return years;
    },
}